import { useRef, useState } from "react";

export function useToast(timeoutMs = 2500) {
  const [toast, setToast] = useState(null);
  const tRef = useRef(null);

  function showToast(text, type = "ok") {
    setToast({ text, type, ts: Date.now() });
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(() => setToast(null), timeoutMs);
  }

  function clearToast() {
    if (tRef.current) clearTimeout(tRef.current);
    setToast(null);
  }

  return { toast, showToast, clearToast };
}